import * as prismic from "@prismicio/client";

export const prismicClient = prismic.createClient(
  process.env.REACT_APP_PRISMIC_REPO_NAME!
);

export const prismicFilter = prismic.filter;
